// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article-sticker__name[data-v-132464fa]{display:inline-block;font-weight:700;font-size:16px;line-height:16px;text-transform:uppercase}@media (max-width:767px){.article-sticker__name[data-v-132464fa]{font-size:14px;line-height:14px}}.article-sticker__img[data-v-132464fa]{width:29px;margin:0 5px 5px 0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}@media (max-width:767px){.article-sticker__img[data-v-132464fa]{margin:0}}", ""]);
// Exports
module.exports = exports;
